export const urlSearchParamsMiddleware = (store) => (next) => (action) => {
  if (
    action.type === "mappingAlias/setURLParams" &&
    action.payload instanceof URLSearchParams
  ) {
    const paramsObject = Object.fromEntries(action.payload.entries());
    action = { ...action, payload: paramsObject };
  }

  return next(action);
};

export const selectSearchParams = (state) => {
  if (
    !state.mappingAlias.urlParams ||
    typeof state.mappingAlias.urlParams !== "object"
  ) {
    return new URLSearchParams();
  }

  return new URLSearchParams(state.mappingAlias.urlParams);
};
